import { httpClient } from '@/shared/api/httpClient';
import type { ChildProfile, IpraSource, Profile } from '@/entities/profile/model/types';
import { env } from '@/shared/config/env';

type SessionResponse = { profile: Profile | null; isAdmin?: boolean } | null;

export interface RegisterProfileDraft {
  customLogin?: string;
  pin: string;
  pin_confirmation: string;
  region?: string;
  city: string;
  street: string;
  ipraSource: IpraSource | null;
  pdnConsent: boolean;
  pdnConsentVersion: string;
  ipraImportToken?: string;
  children: Array<Omit<ChildProfile, 'id'>>;
}

export interface RegisterResult {
  familyId: string;
  loginIdentifier: string;
}

export interface LoginPayload {
  familyId: string;
  pin: string;
}

export interface AdminLoginPayload {
  email: string;
  password: string;
}

export const authClient = {
  previewIpra: (file: File) => {
    const data = new FormData(); data.append('file', file); data.append('pdnConsent', 'true'); data.append('pdnConsentVersion', 'pending-legal-text');
    return httpClient.post<{
      region: string | null;
      city: string | null;
      street: string | null;
      ocrUsed: boolean;
      children: Array<Omit<ChildProfile, 'id'>>;
      ipraImportToken: string}>('/auth/register/ipra/preview', data);
  },
  register: (draft: RegisterProfileDraft) => httpClient.post<RegisterResult>('/auth/register', draft),
  checkLoginAvailability: (login: string) => httpClient.get<{ available: boolean }>(`/auth/register/login-availability?login=${encodeURIComponent(login)}`),
  login: (payload: LoginPayload) => httpClient.post<{ profile: Profile }>('/auth/login', payload),
  adminLogin: (payload: AdminLoginPayload) => httpClient.post<{ ok: true }>('/auth/admin-login', payload),
  logout: (isAdmin = false) => httpClient.post<void>(isAdmin && !env.useMocks ? '/admin/auth/logout' : '/auth/logout'),
  session: (scope: 'family' | 'admin' = 'family'): Promise<SessionResponse> =>
    httpClient.get<SessionResponse>(scope === 'admin' && !env.useMocks ? '/admin/auth/session' : '/auth/session'),
};
